import { render, staticRenderFns } from "./updateOrder.vue?vue&type=template&id=92b66a7a&scoped=true"
import script from "./updateOrder.vue?vue&type=script&lang=js"
export * from "./updateOrder.vue?vue&type=script&lang=js"
import style0 from "./updateOrder.vue?vue&type=style&index=0&id=92b66a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b66a7a",
  null
  
)

export default component.exports